const DMV_ORI_NAME = "vt department of motor vehicles";

const DMV_CALL_TYPE_NAMES = [
  "traffic stop",
  "traffic stop - tact",
];

const DMV_REQUIRED_INCIDENT_FLAG_NAMES = ["patrol", "fixed site"];

function normalizeSetupListName(name) {
  return (name || "").trim().toLowerCase();
}

function hasNameMatch(items = [], allowedNames = []) {
  const allowed = new Set(allowedNames);
  return (items || []).some(item =>
    allowed.has(normalizeSetupListName(item?.name)),
  );
}

function dmvCallTypeRequiresIncidentFlag(callTypeName) {
  return (
    callTypeName.startsWith("inspection") ||
    DMV_CALL_TYPE_NAMES.includes(callTypeName)
  );
}

function validateDmvInspectionFlagRule({ incident }) {
  const callTypeName = normalizeSetupListName(incident?.classification?.name);
  const callTypeRequiresFlag = dmvCallTypeRequiresIncidentFlag(callTypeName);

  if (!callTypeRequiresFlag) {
    return { ok: true, errors: [], sections: {} };
  }

  const hasRequiredIncidentFlag = hasNameMatch(
    incident?.incidentFlags,
    DMV_REQUIRED_INCIDENT_FLAG_NAMES,
  );

  if (hasRequiredIncidentFlag) {
    return { ok: true, errors: [], sections: {} };
  }

  return {
    ok: false,
    errors: [
      "Department of Motor Vehicles requires Patrol or Fixed Site as an incident flag when Call Type is Traffic Stop, Traffic Stop - TACT, or starts with Inspection.",
    ],
    sections: { classification: true, incidentFlags: true },
  };
}

const AGENCY_VALIDATORS = {
  [DMV_ORI_NAME]: [validateDmvInspectionFlagRule],
};

function aggregateValidationResults(results) {
  return results.reduce(
    (acc, res) => {
      if (!res.ok) acc.ok = false;
      acc.errors.push(...(res.errors || []));
      acc.warnings.push(...(res.warnings || []));
      acc.sections = {
        ...acc.sections,
        ...(res.sections || {}),
      };
      return acc;
    },
    { ok: true, errors: [], sections: {}, warnings: [] },
  );
}

export function validateAgencySpecificReview({ incident }) {
  const oriName = normalizeSetupListName(
    incident?.ori?.oriName || incident?.ori?.name,
  );
  const validators = AGENCY_VALIDATORS[oriName] || [];

  if (validators.length === 0) {
    return { ok: true, errors: [], sections: {}, warnings: [] };
  }

  return aggregateValidationResults(
    validators.map(validate => validate({ incident })),
  );
}
